import { type } from "os";

export const ADD_ORGANIZATION = 'ADD_ORGANIZATION';

type OrganizationActionType = typeof ADD_ORGANIZATION;

export interface OrganizationAction{
  type: OrganizationActionType;
  payload: any;
}


export interface servicesLink {
  id?: string;
  url:string;
  service: string;  
  created_at?: string;
  updated_at?: string;
}

export interface TypeOrganization {
    key?: string;
    id?: string;
    emissionTypeOrganization:string;
    name: string;  
    created_at?: string;
    updated_at?: string;
}
export interface Organization {
    id:string,
    ruc:string,
    name:string,
    economicActivity:string;
    description:string;
    msCatalogueCountryId:string;
    msCatalogueCountryName:string;
    status:string;
    createdAt:string;
  }

  
export interface Cities {
  id:string,
  countryId:string,
  name:string,
}